import { useEffect, useState } from 'react'
import { statusCodes } from '../../../Constants/generalConfig';
import { logOutApi, adminDashboardReport, revenuePieChartAdmin, revenueAdmin, countryList } from '../../../Context/api';
import axios from 'axios';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';


const UseDashboard = () => {
    const [spinner, setSpinner] = useState(false)
    const [revenueData, setRevenueData] = useState([])
    const [revenueEarn, setRevenueEarn] = useState([])
    const [revenueEarnPhonepe, setRevenueEarnPhonepe] = useState([])
    const [provider, setProvider] = useState('')
    const [totalServiceProviderMonthly, setTotalServiceProviderMonthly] = useState('')
    const [totalFreePlan, setTotalFreePlan] = useState('')
    const [totalPaidPlan, setTotalPaidPlan] = useState('')
    const [totalRevenueMonthlyStripe, setTotalRevenueMonthlyStripe] = useState('')
    const [totalRevenueMonthlyPhonepe, setTotalRevenueMonthlyPhonepe] = useState('')
    const [conversionRateChartData, setConversionRateChartData] = useState([])
    const [countryData, setCountryData] = useState([])
    const [currentCountry, setCurrentCountry] = useState('')

    const navigate = useNavigate()
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const [filter, setFilter] = useState({
        day: 'MONTHLY',
        payment: 'STRIPE',
        country: 'ALL'
    })

    useEffect(() => {
        conversionRateChart()
        dashboardReport()
        countryListData()
    }, [filter.country])
    useEffect(() => {
        revenue()
    }, [filter.day, filter.payment, filter.country])

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId, userId: adminData.userId, type: 'WEBADMIN' }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        }).catch(()=>{
            
        })
    }
    const dashboardReport = () => {
        const data = {
            days: "THIS_MONTH",
            today: moment(new Date()).format('YYYY-MM-DD'),
            countryId: filter.country
        }
        setSpinner(true)
        axios.post(adminDashboardReport(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setSpinner(false)
                resp.data.data?.map((item) => {
                    if (item.TotalRevenueEarnedStripe) {
                        const revenueSummary = item.TotalRevenueEarnedStripe[0];
                        setRevenueEarn(revenueSummary)
                    }
                    if (item.TotalRevenueEarnedPhonepe) {
                        const revenueSummary = item.TotalRevenueEarnedPhonepe[0];
                        setRevenueEarnPhonepe(revenueSummary)
                    }
                    if (item.TotalServiceProvider) {
                        let totalServiceProviderValue = item.TotalServiceProvider[0].totalProvider;
                        setProvider(totalServiceProviderValue);
                    }
                    if (item.TotalServiceProviderMonthly) {
                        let TotalServiceProviderMonthly = item.TotalServiceProviderMonthly[0];
                        setTotalServiceProviderMonthly(TotalServiceProviderMonthly)
                    }
                    if (item.TotalFreePlan) {
                        let TotalFreePlan = item.TotalFreePlan[0];
                        setTotalFreePlan(TotalFreePlan)
                    }
                    if (item.TotalPaidPlan) {
                        let TotalPaidPlan = item.TotalPaidPlan[0];
                        setTotalPaidPlan(TotalPaidPlan)
                    }
                    if (item.TotalRevenueMonthlyStripe) {
                        let TotalRevenueMonthlyStripe = item.TotalRevenueMonthlyStripe[0];
                        setTotalRevenueMonthlyStripe(TotalRevenueMonthlyStripe)
                    }
                    if (item.TotalRevenueMonthlyPhonepe) {
                        let TotalRevenueMonthlyPhonepe = item.TotalRevenueMonthlyPhonepe[0];
                        setTotalRevenueMonthlyPhonepe(TotalRevenueMonthlyPhonepe)
                    }
                });


            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                setSpinner(false)
            }
        }).catch(()=>{
            
        })
    }
    const conversionRateChart = () => {
        const data = {
            days: "THIS_MONTH",
            today: moment(new Date()).format('YYYY-MM-DD'),
            countryId: filter.country
        }

        setSpinner(true)
        axios.post(revenuePieChartAdmin(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setConversionRateChartData(resp.data.data)
                setSpinner(false)

            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                setSpinner(false)
                setConversionRateChartData([])

            }
        }).catch(()=>{

        })
    }
    const revenue = () => {
        const data = {
            days: "THIS_MONTH",
            today: moment(new Date()).format('YYYY-MM-DD'),
            sortBy: filter.day,
            paymentModes: filter.payment,
            countryId: filter.country
        }

        setSpinner(true)
        axios.post(revenueAdmin(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setRevenueData(resp.data.data)
                setSpinner(false)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                setSpinner(false)
                setRevenueData([])

            }
        })
            .catch(() => {
                setSpinner(false)
            })
    }
    let chartData = []
    chartData = revenueData?.map((element) => {
        let formattedDate;
        switch (filter.day) {
          case 'YEARLY':
            formattedDate = moment(element._id).format('YYYY');
            break;
          case 'DAILY':
            formattedDate = moment(element._id).format('MMM Do');
            break;
          default:
            formattedDate = moment(element._id).format('MMM YY');
            break;
        }
        return {
          _id: formattedDate,
          count: element.count,
          Total_Revenue: element.totalRevenue-element.totalRefund
        };
      });
    const handleChange = (e) => {
        const { name, value } = e.target
        setFilter((prop) => ({
            ...prop,
            [name]: value
        }
        ))
    }
    const countryListData = () => {
        const data = {
            id: adminData.userId,
            isDeleted: true,
            isActive: true,
            searchText: '',
            page: 1,
            count: 100
        }

        axios.post(countryList(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setCountryData(resp.data.data)

            }
            else {
                setCountryData([])
                setSpinner(false)
            }
        }).catch(() => {
                setSpinner(false)
            })
    }
    const countryCheck = (id) => {
        const country = countryData.find((item) => item._id == id)
        setCurrentCountry(country?.name)
    }
    return {
        setSpinner,
        setRevenueData,
        setRevenueEarn,
        setRevenueEarnPhonepe,
        setProvider,
        setTotalServiceProviderMonthly,
        setTotalFreePlan,
        setTotalPaidPlan,
        setTotalRevenueMonthlyStripe,
        setTotalRevenueMonthlyPhonepe,
        setConversionRateChartData,
        setCountryData,
        navigate,
        setFilter,
        handleChange,
        countryCheck,
        spinner,
        revenueData,
        revenueEarn,
        revenueEarnPhonepe,
        provider,
        totalServiceProviderMonthly,
        totalFreePlan,
        totalPaidPlan,
        totalRevenueMonthlyStripe,
        totalRevenueMonthlyPhonepe,
        conversionRateChartData,
        filter,
        countryData,
        chartData,
        currentCountry


    }
}

export default UseDashboard